import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class ScreensPixelsRoute extends Route {
  @service declare router: RouterService;
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;

  beforeModel(): void {
    if (this.abilities.cannot('edit content screens') || !this.featureFlags.isEnabled('screens-pixels')) {
      this.router.transitionTo('unauthorized');
    }
  }
}
